import { Dialog } from "primereact/dialog";
import { useRef, useState } from "react";
import ReactPlayer from "react-player";

const PlayPrensentationVideoDialog = ({
  headerName,
  selectedSlideData,
  isPlayVideoDialogVisible,
  setIsPlayVideoDialogVisible,
  setSelectedSlideData,
  setSelectedPresentation,
  setSelectedSlideIndex,
}) => {
  const [selectedSession, setSelectedSession] = useState(null);
  const playerRef = useRef(null);

  return (
    <Dialog
      header={headerName}
      position={"top"}
      visible={isPlayVideoDialogVisible}
      style={{ width: "50vw" }}
      onHide={() => {
        if (!isPlayVideoDialogVisible) return;
        setIsPlayVideoDialogVisible(false);
        setSelectedSlideData(null);
        setSelectedPresentation(null);
        setSelectedSlideIndex(null);
      }}
      blockScroll
    >
      <ReactPlayer
        ref={playerRef}
        className="w-100"
        style={{ height: "400px" }}
        controls
        onTimeUpdate={(e) => console.log(e.target.value)}
      />
      <div className="position-relative mt-3">
        <div
          className="d-flex overflow-auto pb-3"
          style={{
            scrollBehavior: "smooth",
            gap: "0.5rem",
            whiteSpace: "nowrap",
            backgroundColor: "transparent",
          }}
        >
          {selectedSlideData?.slideVideos?.map((s, i) => (
            <div
              key={i}
              className={`card text-center flex-shrink-0 ${
                selectedSession === i ? "active" : ""
              }`}
              style={{
                width: "215px",
                height: "120px",
                border: "2px solid #999",
                cursor: "pointer",
                borderRadius: "0",
                opacity: selectedSession === i ? 1 : 0.6,
              }}
              onClick={() => setSelectedSession(i)}
            >
              <div className="card-body p-0">
                <div
                  className="position-relative"
                  style={{
                    backgroundColor: "#f8f9fa",
                    height: "81px",
                  }}
                >
                  {/* Play icon overlay */}
                  <i
                    className="pi pi-play-circle"
                    style={{
                      fontSize: "2.5rem",
                      color: "#007bff",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                  />
                </div>
                <div className="mt-2 text-truncate">
                  <strong>{s.name}</strong> - {s.title}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Dialog>
  );
};

export default PlayPrensentationVideoDialog;
